module.exports = __webpack_public_path__ + "media/images/pokerroom/bg-34785ff9b57899f88470b787f0d9b127.jpg";